import { useTranslation } from 'next-i18next';
import { CouponFillIcon } from '@/icons/components/CouponFill';
export const VoucherEmptyState = () => {
  const {
    t
  } = useTranslation(['billing']);
  return <div className="flex w-full flex-col items-center justify-center gap-md px-lg py-2xl" data-sentry-component="VoucherEmptyState" data-sentry-source-file="VoucherEmptyState.tsx">
      <CouponFillIcon size="xl" className="text-gray-300" data-sentry-element="CouponFillIcon" data-sentry-source-file="VoucherEmptyState.tsx" />
      <div className="flex flex-col items-center gap-4xs text-center text-body-lg-medium text-assistive">
        <span>{t('voucher.storage.empty')}</span>
        <span>{t('voucher.storage.empty.description')}</span>
      </div>
    </div>;
};